export default __webpack_public_path__ + "static/it3-20c5e9040c5dd1bb989a3ddc94a8a101.jpg";